import { Helmet } from 'react-helmet';
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Collapse,
    Container,
    Divider,
    Checkbox,
    Grid,
    Typography,
    Paper,
    TextField,
    Switch,
    FormGroup,
    FormControlLabel,
    MenuItem,
    Select,
    FormHelperText
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emtyData from "../../../../assets/images/emty-data.png";
import { Formik } from "formik";
import * as Yup from 'yup';
import DialogIcon from "../../../../components/kpi/DialogIcon";
import IdpService from "../../../../services/idp.service";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown.svg";
import Icon from '@mui/material/Icon';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import { ReactComponent as PlusIcon } from "../../../../assets/icons/plus.svg";
import { ReactComponent as Delete } from "../../../../assets/icons/delete.svg";

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    buttonFile: {
        position: "absolute",
        right: "1px",
        top: "1px",
        // bottom: "9px",
        background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
        borderLeft: "1px solid #CED4DA",
        "border-radius": "0px 4px 4px 0px",
        width: "100px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    dropdowm: {
        position: "absolute",
        right: "20px",
        top: "40%",
        // bottom: "9px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
};

const IDPTemplateCreate = (props) => {
    const { t } = useTranslation();

    useEffect(() => {
    }, []);
    // position: absolute; bottom: -24px
    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        fieldsetError: {
            '& div > fieldset': {
                "border-color": "#CC6058"
            }
        },
        disabled: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                borderRadius: "4px",
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            '& div > input': {
                height: '8px',
                position: "relative"
            }
        },
        input: {
            '& div > input': {
                height: '7px',
                position: "relative"
            }
        },
        inputTopicDisabled: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                borderRadius: "4px",
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > input': {
                padding: "12px 14px",
                "font-size": "16px",
                height: '7px',
                position: "relative"
            }
        },
        inputTopic: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > textarea': {
                padding: "4.5px 14px",
                "font-size": "16px",
                height: '7px',
                position: "relative"
            }
        },
        inputTopicError: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > textarea': {
                padding: "4.5px 14px",
                "font-size": "16px",
                height: '8px',
                position: "relative"
            },
            '& fieldset': {
                "border-color": "#CC6058"
            }
        },
        selectDisabled: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                borderRadius: "4px",
                backgroundColor: "#FAFAFA !important"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            '& div ': {
                padding: "4.05px 14px"
            }
        },
        select: {
            '& div ': {
                padding: "4.05px 14px"
            }
        },
        selectError: {
            '& div ': {
                padding: "4.05px 14px"
            },
            '& fieldset': {
                "border-color": "#CC6058"
            }
        },
        inputError: {
            '& div > input': {
                color: "#CC6058",
                background: "#CC60581A",
                textAlign: "center",
                height: '6px',
                border: "1px solid #CC6058 !important",
                borderRadius: "4px"
            }
        },
        width50: {
            width: "calc(50% - 80px)",
            margin: "0 40px",
        },
        width100: {
            width: "calc(50% - 80px)",
            margin: "0 40px",
        },
        boxInput: {
            ".MuiFormControl-root": {
                "margin-top": "7px"
            }
        },
    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false, state: { cycleID: cycleID } });
    }
    const classes = useStyles();
    let { cycleID, serial } = useParams()
    const [forEmployee, setForEmployee] = React.useState([]);
    const [forManager, setForManager] = React.useState([]);
    const [status, setStatus] = React.useState(true);
    const [onSubmit, setOnSubmit] = React.useState(false);
    const [canEdit, setCanEdit] = React.useState(true);
    const [statusUse, setStatusUse] = React.useState(false);
    const handleStatus = () => {
        setStatus(!status)
    }

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
        "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track": {
            backgroundColor: "#D8D8D8!important"
        }
    }));
    const validationSchema = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.code')),
        name: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
    });
    const formik = useFormik({
        initialValues: {
            code: '',
            name: '',
            description: '',
            forEmployee: [],
            forManager: [],
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            if (checkData() === true) {
                submit(values)
            }
        },
    });

    useEffect(() => {
        IdpService.getIdpTemplate(serial).then((rs) => {
            console.log(rs?.data);
            let forEmployeeData = []
            let forManagerData = []
            setCanEdit(Util.formatData(rs?.data?.cycle?.options?.allow_adjust, false))
            setStatus(Util.formatData(rs?.data?.idp_template?.status, false) === "active" ? true : false)
            if (Util.formatData(rs?.data?.idp_template?.idp_question_template, []).length > 0) {
                forEmployeeData = rs?.data?.idp_template?.idp_question_template.filter((rs) => rs?.type === "self")
                forManagerData = rs?.data?.idp_template?.idp_question_template.filter((rs) => rs?.type === "evaluator")
            }
            console.log(forEmployeeData, forManagerData);
            formik.setFieldValue("code", Util.formatData(rs?.data?.idp_template?.code, ""))
            formik.setFieldValue("name", Util.formatData(rs?.data?.idp_template?.name, ""))
            formik.setFieldValue("description", Util.formatData(rs?.data?.idp_template?.description, ""))
            formik.setFieldValue("forEmployee", forEmployeeData)
            formik.setFieldValue("forManager", forManagerData)
            setForEmployee(forEmployeeData)
            setForManager(forManagerData)
            setStatusUse(rs.data.idp_template.is_used)
        })
            .catch((err) => {

            })
    }, []);

    const checkData = () => {
        let findDataForEmployee = formik.values.forEmployee.length > 0 ? formik.values.forEmployee.filter((res) => res.topic !== "" && res.answer_type !== "") : []
        let findDataForManager = formik.values.forManager.length > 0 ? formik.values.forManager.filter((res) => res.topic !== "" && res.answer_type !== "") : []
        if (findDataForEmployee !== undefined || findDataForManager !== undefined) {
            if (formik.values.forEmployee.length > 0 && formik.values.forManager.length > 0) {
                if (findDataForEmployee !== undefined && findDataForEmployee.length > 0 && findDataForEmployee.length === formik.values.forEmployee.length &&
                    findDataForManager !== undefined && findDataForManager.length > 0 && findDataForManager.length === formik.values.forManager.length) {
                    return true;
                }
                return false;
            } else if (formik.values.forEmployee.length > 0 && findDataForEmployee !== undefined && findDataForEmployee.length > 0 && findDataForEmployee.length === formik.values.forEmployee.length) {
                return true;
            } else if (formik.values.forManager.length > 0 && findDataForManager !== undefined && findDataForManager.length > 0 && findDataForManager.length === formik.values.forManager.length) {
                return true;
            }
        }
        return false;
    }
    const checkDataOne = (data) => {
        let findData = data.filter((res) => res.topic !== "" && res.answer_type !== "")
        if (findData !== undefined && findData.length > 0 && findData.length === data.length) {
            return true;
        }
        return false;
    }

    const handleSubmit = () => {
        let findDataForEmployee = formik.values.forEmployee.filter((res) => res.topic === "" && res.answer_type === "")
        let findDataForManager = formik.values.forManager.filter((res) => res.topic === "" && res.answer_type === "")
        if (findDataForEmployee !== undefined && findDataForEmployee.length > 0) {
            let data = []
            for (let index = 0; index <= formik.values.forEmployee.length - 1; index++) {
                if (formik.values.forEmployee[index]?.answer_type !== "" || formik.values.forEmployee[index]?.topic !== "") {
                    if (formik.values.forEmployee[index]?.answer_type === "" && formik.values.forEmployee[index]?.topic === "") {

                    } else {
                        data.push(formik.values.forEmployee[index])
                    }
                }
            }
            setForEmployee(data)
            formik.setFieldValue("forEmployee", data)
        }
        if (findDataForManager !== undefined && findDataForManager.length > 0) {
            let data = []
            for (let index = 0; index <= formik.values.forManager.length - 1; index++) {
                if (formik.values.forManager[index]?.answer_type !== "" || formik.values.forManager[index]?.topic !== "") {
                    if (formik.values.forManager[index]?.answer_type === "" && formik.values.forManager[index]?.topic === "") {

                    } else {
                        data.push(formik.values.forManager[index])
                    }
                }
            }
            setForManager(data)
            formik.setFieldValue("forManager", data)
        }
        formik.submitForm()
        setOnSubmit(true)
    }
    const addForEmployee = () => {
        setForEmployee([...forEmployee, {}])
        formik.setFieldValue("forEmployee", [...formik.values.forEmployee, { topic: "", answer_type: "", is_required: false }])
    }
    const addForManager = () => {
        setForManager([...forManager, {}])
        formik.setFieldValue("forManager", [...formik.values.forManager, { topic: "", answer_type: "", is_required: false }])
    }
    const formikChange = (val, field, subField, index, type) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        data[field][index] = { ...formik.values[field][index], [subField]: "is_required" === subField ? !formik.values[field][index][subField] : val.target.value }
        formik.setFieldValue(field, data[field])
    }
    const formikDelete = (dataLoop, field, setData, index) => {
        let data = JSON.parse(JSON.stringify(formik.values))
        let dataShow = JSON.parse(JSON.stringify(dataLoop))
        data[field].splice(index, 1)
        dataShow.splice(index, 1)
        setData(dataShow)
        formik.setFieldValue(field, data[field])
    }
    const handleCancel = () => {
        setDiscardDialog(true)
    }

    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        openDialog(false);
        navigate('/admin/idp-template', { replace: false, state: { cycleID: cycleID } });
    };
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const [isAddDialogOpen, openDialog] = React.useState(false);
    const handleOpenDialog = (value) => {
        openDialog(true);
    };
    const handleDirect = () => {
        openSuccessAddDialog(false)
        navigate('/admin/idp-template', { replace: false, state: { cycleID: cycleID } });
    }
    const submit = (data) => {
        let dataAddSeq = JSON.parse(JSON.stringify(data))
        if (Util.formatData(dataAddSeq?.forEmployee, []).length > 0) {
            for (let index = 0; index <= dataAddSeq.forEmployee.length - 1; index++) {
                dataAddSeq.forEmployee[index].seq = index + 1
            }
        }
        if (Util.formatData(dataAddSeq?.forManager, []).length > 0) {
            for (let index = 0; index <= dataAddSeq.forManager.length - 1; index++) {
                dataAddSeq.forManager[index].seq = index + 1
            }
        }
        let dt = {
            cycle_id: cycleID,
            code: dataAddSeq?.code,
            name: dataAddSeq?.name,
            description: dataAddSeq?.description,
            status: status ? "active" : "inactive",
            options: {
                self: Util.formatData(dataAddSeq?.forEmployee, []),
                evaluator: Util.formatData(dataAddSeq?.forManager, [])
            }
        }
        IdpService.updateIdpTemplate(serial, dt).then((rs) => {
            openSuccessAddDialog(true)
        }).catch((err) => {

        })
    }
    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/idp-template')}>{t('admin.label.idpTemplate')}</span> / <span style={styles.end} >{t('admin.label.editIDPTemplate')}</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <Typography variant="h1" color="#404349" fontSize={36} lineHeight="53.82px" fontWeight="500">
                                {t('admin.label.editIDPTemplate')}
                            </Typography>
                        </Grid>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">
                            <Grid container item>
                                <Paper sx={{ padding: "40px 40px 20px", "box-shadow": " 0px 2px 10px rgba(0, 0, 0, 0.1)", "border-radius": "10px", width: '100%' }} classes={{ root: classes.error }}>
                                    <Box display="flex" sx={{ margin: "0 -40px", flexFlow: "row wrap" }}>
                                        <Box sx={{ width: "calc(50% - 80px)", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" }, ".MuiFormHelperText-root": { position: "absolute", bottom: "-23px" } }} >
                                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.code')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.code && formik.errors.code)}
                                                fullWidth
                                                helperText={formik.touched.code && formik.errors.code}
                                                margin="normal"
                                                name="code"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.code}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                inputProps={{
                                                    sx: {
                                                        "&::placeholder": {
                                                            color: "#AAAAAA",
                                                            fontWeight: "300",
                                                            opacity: "1"
                                                        }
                                                    }
                                                }}
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                placeholder={t('admin.inputForm.placeholder.code')}
                                                disabled
                                                classes={{ root: classes.disabled }}
                                            />
                                        </Box>
                                        <Box sx={{ width: "calc(50% - 80px)", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" } }}>
                                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.status')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <Box sx={{ "margin-top": "7px", height: "41px", display: "flex", "align-items": "center", ".MuiFormControlLabel-root .MuiFormControlLabel-label.Mui-disabled": { color: '#404349' } }}>
                                                <FormGroup >
                                                    <FormControlLabel
                                                        sx={{ m: 0, ".MuiTypography-root": { color: "#404349" } }}
                                                        control={<IOSSwitch checked={status} disabled={statusUse === true ? true : false} onChange={() => canEdit ? handleStatus() : null} />}
                                                        label={status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                                                    // disabled
                                                    />
                                                </FormGroup>
                                                {/* <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography> */}
                                            </Box>
                                        </Box>
                                        <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" }, ".MuiFormHelperText-root": { position: "absolute", bottom: "-23px" } }}>
                                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.name')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.name && formik.errors.name)}
                                                fullWidth
                                                helperText={formik.touched.name && formik.errors.name}
                                                margin="normal"
                                                name="name"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.name}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                inputProps={{
                                                    sx: {
                                                        "&::placeholder": {
                                                            color: "#AAAAAA",
                                                            fontWeight: "300",
                                                            opacity: "1"
                                                        }
                                                    }
                                                }}
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                placeholder={t('admin.inputForm.placeholder.nameIDP')}
                                                disabled={!canEdit}
                                                classes={canEdit ? { root: classes.input } : { root: classes.disabled }}
                                            />
                                        </Box>
                                        <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px", ".MuiFormControl-root": { "margin-top": "7px" } }}>
                                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.description')}</Typography>
                                            <TextField
                                                fullWidth
                                                margin="normal"
                                                name="description"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.description}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                inputProps={{
                                                    sx: {
                                                        "&::placeholder": {
                                                            color: "#AAAAAA",
                                                            fontWeight: "300",
                                                            opacity: "1"
                                                        }
                                                    }
                                                }}
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                placeholder={t('admin.inputForm.placeholder.descriptionIDP')}
                                                disabled={!canEdit}
                                                classes={canEdit ? { root: classes.input } : { root: classes.disabled }}
                                            />
                                        </Box>
                                        <Box pt="17px" sx={{ width: "calc(100% - 80px)", margin: "0 40px" }}>
                                            <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.question')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box><span style={{ color: "#939393", "font-weight": "300", "font-size": "16px", "line-height": "24px", "padding-left": "10px", fontStyle: "italic" }}>-{t('admin.inputForm.requireAtLeast')}</span></Typography>
                                            <Box sx={{ position: "relative" }}>
                                                <Box mt="10px" sx={{ border: onSubmit === true ? forEmployee.length === 0 && forManager.length === 0 ? "1px solid #CC6058" : "1px solid #CED4DA" : "1px solid #CED4DA", "box-sizing": "border-box", "border-radius": "4px", padding: "17px 29px" }}>
                                                    <Box sx={{ display: "flex", "align-items": "center", "justify-content": "space-between" }}>
                                                        <Typography fontWeight="500" color="#404349" fontSize={16} lineHeight="23.92px" display="flex">{t('admin.inputForm.forEmployee')}</Typography>
                                                        {canEdit ? <Box onClick={addForEmployee} sx={{ cursor: "pointer", width: "max-content", display: "flex", "flex-direction": "row", "justify-content": "center", "align-items": "center", padding: "4px 10px", "border-radius": "4px", }}>
                                                            <PlusIcon />
                                                            <Typography pl="5px" fontWeight="500" color="#5DA196" fontSize={18} lineHeight="26.91px" display="flex">
                                                                {/* {t('label.add')} */}
                                                                Add
                                                            </Typography>
                                                        </Box>
                                                            : null
                                                        }
                                                    </Box>
                                                    <Collapse in={forEmployee !== undefined && forEmployee !== null && forEmployee.length > 0}>
                                                        {forEmployee !== undefined && forEmployee !== null && forEmployee.length > 0 ?
                                                            <Box pb="16px">
                                                                <Box sx={{ width: "100%", background: "#FAFAFA", }} mt="16px">
                                                                    <Divider />
                                                                    <Box sx={{ height: "48px", padding: "0 25px", display: "flex", "align-items": "center" }}>
                                                                        <Box sx={{ width: "calc(100% - 420px)" }}>
                                                                            <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">{t('admin.label.topic')}</Typography>
                                                                        </Box>
                                                                        <Box sx={{ width: "250px" }}>
                                                                            <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">{t('admin.label.answerType')}</Typography>
                                                                        </Box>
                                                                        <Box sx={{ width: "110px" }}>
                                                                            <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">{t('admin.label.required')}</Typography>
                                                                        </Box>
                                                                        <Box sx={{ width: "60px" }}>
                                                                            <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">{t('admin.label.action')}</Typography>
                                                                        </Box>
                                                                    </Box>
                                                                    <Divider />
                                                                </Box>
                                                                {forEmployee.map((item, index) => (
                                                                    <Box sx={{ width: "100%" }} >
                                                                        <Box sx={{ minHeight: "49px", padding: "0 25px", display: "flex", }}>
                                                                            <Box sx={{ width: "calc(100% - 420px)", '.MuiOutlinedInput-root': { "padding": "0px !important" }, }} py="8.5px" pr="40px">
                                                                                <TextField
                                                                                    // error={Boolean(formik.touched.name && formik.errors.name)}
                                                                                    fullWidth
                                                                                    // helperText={formik.touched.name && formik.errors.name}
                                                                                    margin="normal"
                                                                                    name="topic"
                                                                                    onBlur={formik.handleBlur}
                                                                                    onChange={e => formikChange(e, "forEmployee", "topic", index)}
                                                                                    type="text"
                                                                                    value={formik.values.forEmployee[index]?.topic}
                                                                                    variant="outlined"
                                                                                    InputLabelProps={{
                                                                                        shrink: true,
                                                                                    }}
                                                                                    inputProps={{
                                                                                        sx: {
                                                                                            "&::placeholder": {
                                                                                                color: "#AAAAAA",
                                                                                                fontWeight: "300",
                                                                                                opacity: "1"
                                                                                            }
                                                                                        }
                                                                                    }}
                                                                                    multiline
                                                                                    sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                                                    placeholder={t('admin.inputForm.placeholder.fillTheTopic')}
                                                                                    disabled={!canEdit}
                                                                                    classes={canEdit ? onSubmit === true ? formik.values.forEmployee[index]?.topic === "" ? { root: classes.inputTopicError } : { root: classes.inputTopic } : { root: classes.inputTopic } : { root: classes.inputTopicDisabled }}
                                                                                />
                                                                            </Box>
                                                                            <Box sx={{ width: "250px" }} py="8.5px" pr="40px">
                                                                                <Select
                                                                                    // id={`${item.key}`}
                                                                                    variant="outlined"
                                                                                    defaultValue=""
                                                                                    displayEmpty
                                                                                    size="small"
                                                                                    placeholder={t('admin.inputForm.placeholder.selectAnswerType')}
                                                                                    fullWidth
                                                                                    // disabled={item.edit === false ? true : false}selectError
                                                                                    className="white-bg"
                                                                                    onChange={e => formikChange(e, "forEmployee", "answer_type", index, "select")}
                                                                                    value={formik.values.forEmployee[index]?.answer_type}
                                                                                    // classes={{ root: classes.select }}
                                                                                    disabled={!canEdit}
                                                                                    classes={canEdit ? onSubmit === true ? formik.values.forEmployee[index]?.answer_type === "" ? { root: classes.selectError } : { root: classes.select } : { root: classes.select } : { root: classes.selectDisabled }}
                                                                                // onChange={selectField(`${item.key}`)}
                                                                                // sx={Boolean(formik.touched[item.key] && formik.errors[item.key]) ? { border: "0.5px solid red", marginTop: "10px", marginBottom: 0 } : { marginTop: "10px", marginBottom: 0 }}
                                                                                >
                                                                                    <MenuItem disabled value="" key="0">
                                                                                        <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>{t("admin.inputForm.placeholder.selectAnswerType")}</Typography>
                                                                                    </MenuItem>
                                                                                    <MenuItem value="textbox" key="1" >
                                                                                        <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>Text Box</span>
                                                                                    </MenuItem>
                                                                                    <MenuItem value="itembox" key="2" >
                                                                                        <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>Item Box</span>
                                                                                    </MenuItem>
                                                                                </Select>
                                                                            </Box>
                                                                            <Box pl="15px" sx={{ width: "110px", ".MuiCheckbox-colorPrimary": { padding: "0" } }} py="11.5px">
                                                                                <Checkbox checked={formik.values.forEmployee[index]?.is_required} onChange={e => canEdit ? formikChange(e, "forEmployee", "is_required", index) : null} />
                                                                            </Box>
                                                                            <Box sx={{ width: "60px", "padding-left": "10px", height: "20px" }} my="14.5px">
                                                                                <Delete style={{ cursor: "pointer" }} onClick={e => canEdit ? formikDelete(forEmployee, "forEmployee", setForEmployee, index) : null} />
                                                                            </Box>
                                                                        </Box>
                                                                        <Divider />
                                                                    </Box>
                                                                ))
                                                                }
                                                            </Box>
                                                            :
                                                            null
                                                        }
                                                    </Collapse>
                                                </Box>
                                                {onSubmit === true ? forEmployee.length > 0 || forManager.length > 0 ? forEmployee.length > 0 && checkDataOne(formik.values.forEmployee) === false ?
                                                    <Typography fontWeight="400" color="#d32f2f" fontSize="0.75rem" lineHeight="1.66" sx={{ "margin-top": "3px", "margin-right": "14px", "margin-bottom": "0", "margin-left": "14px" }}>{t('admin.inputForm.msgError.code')}</Typography>
                                                    : null : null : null}
                                            </Box>
                                        </Box>
                                        <Box pt="30px" sx={{ width: "calc(100% - 80px)", margin: "0 40px", position: "relative" }}>
                                            <Box sx={{ border: onSubmit === true ? forEmployee.length === 0 && forManager.length === 0 ? "1px solid #CC6058" : "1px solid #CED4DA" : "1px solid #CED4DA", "box-sizing": "border-box", "border-radius": "4px", padding: "17px 29px" }}>
                                                <Box sx={{ display: "flex", "align-items": "center", "justify-content": "space-between" }}>
                                                    <Typography fontWeight="500" color="#404349" fontSize={16} lineHeight="23.92px" display="flex">{t('admin.inputForm.forManager')}</Typography>
                                                    {canEdit ? <Box onClick={addForManager} sx={{ cursor: "pointer", width: "max-content", display: "flex", "flex-direction": "row", "justify-content": "center", "align-items": "center", padding: "4px 10px", "border-radius": "4px", }}>
                                                        <PlusIcon />
                                                        <Typography pl="5px" fontWeight="500" color="#5DA196" fontSize={18} lineHeight="26.91px" display="flex">
                                                            {/* {t('label.add')} */}
                                                            Add
                                                        </Typography>
                                                    </Box>
                                                        : null}
                                                </Box>
                                                {forManager !== undefined && forManager !== null && forManager.length > 0 ?
                                                    <Box pb="16px">
                                                        <Box sx={{ width: "100%", background: "#FAFAFA", }} mt="16px">
                                                            <Divider />
                                                            <Box sx={{ height: "48px", padding: "0 25px", display: "flex", "align-items": "center" }}>
                                                                <Box sx={{ width: "calc(100% - 420px)" }}>
                                                                    <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">{t('admin.label.topic')}</Typography>
                                                                </Box>
                                                                <Box sx={{ width: "250px" }}>
                                                                    <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">{t('admin.label.answerType')}</Typography>
                                                                </Box>
                                                                <Box sx={{ width: "110px" }}>
                                                                    <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">{t('admin.label.required')}</Typography>
                                                                </Box>
                                                                <Box sx={{ width: "60px" }}>
                                                                    <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">{t('admin.label.action')}</Typography>
                                                                </Box>
                                                            </Box>
                                                            <Divider />
                                                        </Box>
                                                        {forManager.map((item, index) => (
                                                            <Box sx={{ width: "100%" }} >
                                                                <Box sx={{ minHeight: "49px", padding: "0 25px", display: "flex", }}>
                                                                    <Box sx={{ width: "calc(100% - 420px)", '.MuiOutlinedInput-root': { "padding": "0px !important" }, }} py="8.5px" pr="40px">
                                                                        <TextField
                                                                            // error={Boolean(formik.touched.name && formik.errors.name)}
                                                                            fullWidth
                                                                            // helperText={formik.touched.name && formik.errors.name}
                                                                            margin="normal"
                                                                            name="topic"
                                                                            onBlur={formik.handleBlur}
                                                                            onChange={e => formikChange(e, "forManager", "topic", index)}
                                                                            type="text"
                                                                            value={formik.values.forManager[index]?.topic}
                                                                            variant="outlined"
                                                                            InputLabelProps={{
                                                                                shrink: true,
                                                                            }}
                                                                            inputProps={{
                                                                                sx: {
                                                                                    "&::placeholder": {
                                                                                        color: "#AAAAAA",
                                                                                        fontWeight: "300",
                                                                                        opacity: "1"
                                                                                    }
                                                                                }
                                                                            }}
                                                                            multiline
                                                                            sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                                            placeholder={t('admin.inputForm.placeholder.fillTheTopic')}
                                                                            disabled={!canEdit}
                                                                            classes={canEdit ? onSubmit === true ? formik.values.forManager[index]?.topic === "" ? { root: classes.inputTopicError } : { root: classes.inputTopic } : { root: classes.inputTopic } : { root: classes.inputTopicDisabled }}
                                                                        />
                                                                    </Box>
                                                                    <Box sx={{ width: "250px" }} py="8.5px" pr="40px">
                                                                        <Select
                                                                            // id={`${item.key}`}
                                                                            variant="outlined"
                                                                            defaultValue=""
                                                                            displayEmpty
                                                                            size="small"
                                                                            placeholder={t('admin.inputForm.placeholder.selectAnswerType')}
                                                                            fullWidth
                                                                            // disabled={item.edit === false ? true : false}selectError
                                                                            className="white-bg"
                                                                            onChange={e => formikChange(e, "forManager", "answer_type", index, "select")}
                                                                            value={formik.values.forManager[index]?.answer_type}
                                                                            // classes={{ root: classes.select }}
                                                                            disabled={!canEdit}
                                                                            classes={canEdit ? onSubmit === true ? formik.values.forEmployee[index]?.answer_type === "" ? { root: classes.selectError } : { root: classes.select } : { root: classes.select } : { root: classes.selectDisabled }}
                                                                        // onChange={selectField(`${item.key}`)}
                                                                        // sx={Boolean(formik.touched[item.key] && formik.errors[item.key]) ? { border: "0.5px solid red", marginTop: "10px", marginBottom: 0 } : { marginTop: "10px", marginBottom: 0 }}
                                                                        >
                                                                            <MenuItem disabled value="" key="0">
                                                                                <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>{t("admin.inputForm.placeholder.selectAnswerType")}</Typography>
                                                                            </MenuItem>
                                                                            <MenuItem value="textbox" key="1" >
                                                                                <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>Text Box</span>
                                                                            </MenuItem>
                                                                            <MenuItem value="itembox" key="2" >
                                                                                <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>Item Box</span>
                                                                            </MenuItem>
                                                                        </Select>
                                                                    </Box>
                                                                    <Box pl="15px" sx={{ width: "110px", ".MuiCheckbox-colorPrimary": { padding: "0" } }} py="11.5px">
                                                                        <Checkbox checked={formik.values.forManager[index]?.is_required} onChange={e => canEdit ? formikChange(e, "forManager", "is_required", index) : null} />
                                                                    </Box>
                                                                    <Box sx={{ width: "60px", "padding-left": "10px", height: "20px" }} my="14.5px">
                                                                        <Delete style={{ cursor: "pointer" }} onClick={e => canEdit ? formikDelete(forManager, "forManager", setForManager, index) : null} />
                                                                    </Box>
                                                                </Box>
                                                                <Divider />
                                                            </Box>
                                                        ))
                                                        }
                                                    </Box>
                                                    :
                                                    null
                                                }
                                            </Box>
                                            {onSubmit === true ? forEmployee.length > 0 || forManager.length > 0 ? forManager.length > 0 && checkDataOne(formik.values.forManager) === false ?
                                                <Typography fontWeight="400" color="#d32f2f" fontSize="0.75rem" lineHeight="1.66" sx={{ position: "absolute", "margin-top": "3px", "margin-right": "14px", "margin-bottom": "0", "margin-left": "14px" }}>{t('admin.inputForm.msgError.code')}</Typography>
                                                : null : null : null}
                                            {onSubmit === true && forEmployee.length < 1 && forManager.length < 1 ?
                                                <Typography fontWeight="400" color="#d32f2f" fontSize="0.75rem" lineHeight="1.66" sx={{ position: "absolute", "margin-top": "3px", "margin-right": "14px", "margin-bottom": "0", "margin-left": "14px" }}>{t('admin.inputForm.msgError.atLeast')}</Typography>
                                                :
                                                null
                                            }
                                        </Box>
                                    </Box>
                                    <Box mt="30px">
                                        <Box display="flex" flexDirection="row-reverse">
                                            <Box sx={{ width: "100px" }}>
                                                <Button onClick={handleSubmit} disabled={!canEdit} color="primary" variant="contained" fullWidth sx={{ textTransform: "none" }}>
                                                    {/* {t('label.save')} */}
                                                    <Typography fontSize={18} lineHeight="29px" fontWeight="500" color="#FFF">Save</Typography>
                                                </Button>
                                            </Box>
                                            <Box mr={2} sx={{ width: "100px" }}>
                                                <Button color="black" variant="outlined" fullWidth onClick={handleCancel} sx={{ textTransform: "none" }}>
                                                    <Typography fontSize={18} lineHeight="29px" fontWeight="500" color="#6B6B6B">Cancel</Typography>
                                                    {/* {t('label.cancel')} */}
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <SimpleDialog
                        open={isSuccessAddDialogOpen}
                        doDirect={() => handleDirect()}
                        setValue={openSuccessAddDialog}
                        text={t('admin.label.idpEditSuccessfully')}
                        page={true}
                    />
                    {/* <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title="ดำเนินการไม่สำเร็จ"
                        text={errorText + " \nใหม่อีกครั้ง"}
                    /> */}
                    <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t('label.confirmationOfDiscard')} text={t('label.youSureDiscardChange')} />
                </Container>
            </Box >
        </>
    )
};
export default IDPTemplateCreate;
